import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import {
	Layout,
	Badge,
	message,
	Card,
	Modal,
	Button,
	Form,
	Table,
	Select,
	Input,
	InputNumber,
	List,
	Row,
	Col,
	Divider,
	Space,
	Popconfirm,
} from "antd";
import { PlusOutlined, CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import {
	useGetAllocationQuery,
	useUpdateBatchRecordMutation,
	useGetOrderDataByDateQuery,
} from "@/redux/services/allocationApi";
import { useGetProductListQuery } from "@/redux/services/productApi";
import {
	useUpdateRecordByProductIdMutation,
	useAddNewRecordMutation,
	useGetUserListQuery,
	useDeleteRecordMutation,
} from "@/redux/services/recordApi";
import { useGetPickupLocationQuery } from "@/redux/services/pickupApi";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
//import { ToolTipForm } from "./ToolTipForm";

const { Option } = Select;
const { TextArea } = Input;

const EditableCell = ({
	editing,
	dataIndex,
	title,
	inputType,
	record,
	index,
	children,
	form,
	onDataChange,
	onSelectChange,
	onSelectChange2,
	...restProps
}) => {
	const handleInputChange = (value) => {
		onDataChange(record.order_id, dataIndex, value);
	};

	const handleSelectChange2 = (value) => {
		onSelectChange2(record.order_id, value);
	};

	const inputNode =
		inputType === "select2" ? (
			<Select
				onChange={handleSelectChange2}
				placeholder="状态"
				optionLabelProp="label"
				defaultActiveFirstOption={false}
				filterOption={false}
				style={{ width: "100%" }}
			>
				{StatusList.map((status) => (
					<Option key={status} value={status} label={status}></Option>
				))}
			</Select>
		) : dataIndex === "comment" ? (
			<TextArea
				onChange={(e) => handleInputChange(e.target.value)}
				autoSize={{ minRows: 1, maxRows: 3 }}
				style={{ resize: "none" }}
			/>
		) : (
			<Input onChange={(e) => handleInputChange(e.target.value)} />
		);

	return (
		<td {...restProps}>
			{editing ? (
				<Form.Item
					name={`${dataIndex}_${record.order_id}`}
					style={{ margin: 0 }}
				>
					{inputNode}
				</Form.Item>
			) : (
				children
			)}
		</td>
	);
};

const StatusList = ["确认", "取消"];
const EMPTY_RECORDS = [];

const AllocationPage = () => {
	const { Content } = Layout;
	const [messageApi, contextHolder] = message.useMessage();
	const [updateBatchRecord] = useUpdateBatchRecordMutation();
	const [form] = Form.useForm();
	const [addForm] = Form.useForm();

	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth() + 1;
	const [year, setYear] = useState(currentYear);
	const [month, setMonth] = useState(currentMonth);
	const [modalVisible, setModalVisible] = useState(false);
	const [selectedItem, setSelectedItem] = useState("");
	const [allocationData, setAllocationData] = useState([]);

	const [title, setTitle] = useState("");
	const [calendarType, setCalendarType] = useState("dayGridMonth");

	const [tempLocationName, setTempLocationName] = useState("");
	const inputRef = useRef(null);

	const [moveModalVisible, setMoveModalVisible] = useState(false);
	const [moveSelectedItem, setMoveSelectedItem] = useState(null);
	const [newProductId, setNewProductId] = useState("");

	const [addModalVisible, setAddModalVisible] = useState(false);

	const {
		data: calendarRecordData,
		error: listError,
		refetch: refetchRecordData,
	} = useGetAllocationQuery({ year: year, month: month });
	const recordData = Array.isArray(calendarRecordData)
		? calendarRecordData
		: EMPTY_RECORDS;
	const {
		error: detailError,
		isLoading: loading,
		refetch: refetchAllocationData,
	} = useGetOrderDataByDateQuery({ travelDate: selectedItem });

	const { data: productList } = useGetProductListQuery();
	const { data: userList } = useGetUserListQuery({ roleId: 2 });
	//const { data: LocationList } = useGetPickupLocationListQuery();
	const { data: initialLocationList } = useGetPickupLocationQuery();
	const [LocationList, setLocationList] = useState(initialLocationList || []);

	useEffect(() => {
		if (initialLocationList) {
			setLocationList(initialLocationList.map(location => location.location_name));
		}
	}, [initialLocationList]);

	const [updateRecordByProductId] = useUpdateRecordByProductIdMutation();
	const [addNewRecord] = useAddNewRecordMutation();
	const [deleteRecord] = useDeleteRecordMutation();

	const showModal = (item) => {
		setModalVisible(true);
		setSelectedItem(item);
	};

	const handleCancel = () => {
		setModalVisible(false);
		setSelectedItem("");
		setAllocationData([]);
	};

	const showMoveModal = (record) => {
		setMoveModalVisible(true);
		setMoveSelectedItem(record);
		if (record) {
			setNewProductId(record?.product_id);
		}
	};

	const handleMoveCancel = () => {
		setMoveModalVisible(false);
		setMoveSelectedItem(null);
		setNewProductId("");
	};

	const handleMoveSubmit = async () => {
		try {
			if (moveSelectedItem.product_id === newProductId) {
				messageApi.open({
					type: "error",
					content: "请移动到不同的项目!",
				});
				return;
			}
			const result = await updateRecordByProductId({
				record_id: moveSelectedItem.order_id,
				product_id: newProductId,
			});

			if (result.data.code === "200") {
				messageApi.open({
					type: "success",
					content: "移动成功!请等待数据刷新!",
				});

				setAllocationData([]);

				refetchAllocationData().then((response) => {
					if (response && response.data) {
						const responseData = [...response.data.allocationList];
						responseData.sort((a, b) => {
							if (a.order_date < b.order_date) return 1;
							if (a.order_date >= b.order_date) return -1;
						});

						const newData = JSON.parse(
							JSON.stringify(responseData)
						);

						const groupedData = newData.reduce((acc, curr) => {
							// 获取当前订单的 product_id
							const productId = curr.product_id;
							// 如果当前 product_id 在结果对象中不存在，则创建一个新的数组作为值
							if (!acc[productId]) {
								acc[productId] = [];
							}
							// 将当前订单添加到相应的数组中
							acc[productId].push(curr);
							return acc;
						}, {});

						setAllocationData(groupedData);
						updateFormData(newData);
					}
				});

				refetchRecordData();

				setMoveModalVisible(false);
				setMoveSelectedItem(null);
				setNewProductId("");
			} else {
				console.log(result);
				messageApi.open({
					type: "error",
					content: "移动订单失败!请刷新后重新尝试!",
				});
			}
		} catch (error) {
			console.log(error);
			messageApi.open({
				type: "error",
				content: "移动订单失败!请刷新后重新尝试!",
			});
		}
	};

	const showAddModal = () => {
		setAddModalVisible(true);
		addForm.setFieldValue("order_id", "NEW" + new Date().getTime());
		addForm.setFieldValue("child_no", 0);
		addForm.setFieldValue("adult_no", 0);
		addForm.setFieldValue("price", 0);
	};

	const handleAddCancel = () => {
		setAddModalVisible(false);
		addForm.resetFields();
	};

	const handleAddSubmit = async () => {
		const formData = addForm.getFieldsValue();
		if (isStringEmpty(formData.order_id)) {
			messageApi.open({
				type: "error",
				content: "请输入Order ID!",
			});
			return;
		}

		if (formData.user_id === null || formData.user_id === undefined) {
			messageApi.open({
				type: "error",
				content: "请选择供应商!",
			});
			return;
		}

		if (isStringEmpty(formData.product_id)) {
			messageApi.open({
				type: "error",
				content: "请选择项目!",
			});
			return;
		}

		if (isStringEmpty(formData.client_name)) {
			messageApi.open({
				type: "error",
				content: "请输入客户姓名!",
			});
			return;
		}

		if (isStringEmpty(formData.client_phone)) {
			messageApi.open({
				type: "error",
				content: "请输入客户电话!",
			});
			return;
		}

		if (isStringEmpty(formData.pickup_location)) {
			messageApi.open({
				type: "error",
				content: "请选择上车地点!",
			});
			return;
		}

		if (!isPositiveInteger(formData.adult_no)) {
			messageApi.open({
				type: "error",
				content: "请检查成人人数!",
			});
			return;
		}

		if (!isPositiveInteger(formData.child_no)) {
			messageApi.open({
				type: "error",
				content: "请检查儿童人数!",
			});
			return;
		}

		const requestData = {
			order_id: formData.order_id,
			status: true,
			order_datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
			travel_date: selectedItem,
			total_price: formData.price,
			user_id: formData.user_id,
			client_name: formData.client_name,
			client_phone: formData.client_phone,
			client_email: formData.client_email ?? "",
			pickup_location: formData.pickup_location,
			type: null,
			product_id: formData.product_id,
			people_no: formData.adult_no + formData.child_no,
			option: null,
			comment: formData.comment ?? "",
			raw_people_no:
				"儿童 x " + formData.child_no + ", 成人 x " + formData.adult_no,
		};

		try {
			const result = await addNewRecord(requestData);

			if (result.data.code === "200") {
				messageApi.open({
					type: "success",
					content: "移动成功!请等待数据刷新!",
				});

				setAllocationData([]);

				refetchAllocationData().then((response) => {
					if (response && response.data) {
						const responseData = [...response.data.allocationList];
						responseData.sort((a, b) => {
							if (a.order_date < b.order_date) return 1;
							if (a.order_date >= b.order_date) return -1;
						});

						const newData = JSON.parse(
							JSON.stringify(responseData)
						);

						const groupedData = newData.reduce((acc, curr) => {
							// 获取当前订单的 product_id
							const productId = curr.product_id;
							// 如果当前 product_id 在结果对象中不存在，则创建一个新的数组作为值
							if (!acc[productId]) {
								acc[productId] = [];
							}
							// 将当前订单添加到相应的数组中
							acc[productId].push(curr);
							return acc;
						}, {});

						setAllocationData(groupedData);
						updateFormData(newData);
					}
				});

				refetchRecordData();

				setAddModalVisible(false);
				addForm.resetFields();
			} else {
				console.log(result);
				messageApi.open({
					type: "error",
					content: "新增订单失败!请刷新后重新尝试!",
				});
			}
		} catch (error) {
			console.log(error);
			messageApi.open({
				type: "error",
				content: "新增订单失败!请刷新后重新尝试!",
			});
		}
	};

	const deleteThisRecord = async (record) => {
		try {
			const result = await deleteRecord(record.order_id);

			if (result.data.code === "200") {
				messageApi.open({
					type: "success",
					content: "移动成功!请等待数据刷新!",
				});

				setAllocationData([]);

				refetchAllocationData().then((response) => {
					if (response && response.data) {
						const responseData = [...response.data.allocationList];
						responseData.sort((a, b) => {
							if (a.order_date < b.order_date) return 1;
							if (a.order_date >= b.order_date) return -1;
						});

						const newData = JSON.parse(
							JSON.stringify(responseData)
						);

						const groupedData = newData.reduce((acc, curr) => {
							// 获取当前订单的 product_id
							const productId = curr.product_id;
							// 如果当前 product_id 在结果对象中不存在，则创建一个新的数组作为值
							if (!acc[productId]) {
								acc[productId] = [];
							}
							// 将当前订单添加到相应的数组中
							acc[productId].push(curr);
							return acc;
						}, {});

						setAllocationData(groupedData);
						updateFormData(newData);
					}
				});

				refetchRecordData();
			}
			else {
				console.log(result);
				messageApi.open({
					type: "error",
					content: "删除订单失败!请刷新后重新尝试!",
				});
			}
		}
		catch (error) {
			console.log(error);
			messageApi.open({
				type: "error",
				content: "删除订单失败!请刷新后重新尝试!",
			});
		}
	}

	const isStringEmpty = (str) => {
		return str === null || str === undefined || str.trim() === "";
	};

	const isPositiveInteger = (number) => {
		return Number.isInteger(number) && number >= 0;
	};

	useEffect(() => {
		if (listError) {
			console.error("Loading Data Error:", listError);
			messageApi.open({
				type: "error",
				content: "Loading Data Error!",
			});
		}
		if (detailError) {
			console.error("Loading Data Error:", detailError);
			messageApi.open({
				type: "error",
				content: "Loading Data Error!",
			});
		}
	}, [listError, detailError]);

	useEffect(() => {
		refetchRecordData();
	}, [year, month, refetchRecordData]);

	useEffect(() => {
		if (calendarType === "dayGridMonth") {
			const data = recordData?.filter(
				(eachRecord) =>
					moment(eachRecord.travel_date).format("MM") === month
			);
			const dayTitle = `${year}年${month}月`;

			const sum_people = data?.reduce(
				(acc, curr) => acc + (curr.total_people_no || 0),
				0
			);

			const newTitle = `${dayTitle} (总人数: ${sum_people ?? 0})`;
			setTitle(newTitle);
		}
	}, [recordData]);

	useEffect(() => {
		refetchAllocationData().then((response) => {
			if (response && response.data) {
				const responseData = [...response.data.allocationList];
				responseData.sort((a, b) => {
					if (a.order_date < b.order_date) return 1;
					if (a.order_date >= b.order_date) return -1;
				});

				const newData = JSON.parse(JSON.stringify(responseData));

				const groupedData = newData.reduce((acc, curr) => {
					// 获取当前订单的 product_id
					const productId = curr.product_id;
					// 如果当前 product_id 在结果对象中不存在，则创建一个新的数组作为值
					if (!acc[productId]) {
						acc[productId] = [];
					}
					// 将当前订单添加到相应的数组中
					acc[productId].push(curr);
					return acc;
				}, {});

				setAllocationData(groupedData);
				updateFormData(newData);
			}
		});
	}, [selectedItem, refetchAllocationData]);

	const handleDatesSet = (arg) => {
		const view = arg.view;

		const startDate = moment(arg.start);
		const endDate = moment(arg.end).subtract(1, "days");
		const middleDate = startDate
			.clone()
			.add(endDate.diff(startDate, "days") / 2, "days");

		setYear(middleDate.format("YYYY"));
		setMonth(middleDate.format("MM"));
		setCalendarType(view.type);

		var data = [];
		var dayTitle = "";

		if (view.type === "dayGridWeek") {
			data = recordData?.filter(
				(eachRecord) =>
					moment(eachRecord.travel_date) >= startDate &&
					moment(eachRecord.travel_date) <= endDate
			);
			//2024年6月9日 – 15日
			dayTitle = `${startDate.format("YYYY")}年${startDate.format(
				"MM"
			)}月${startDate.format("DD")}日-${endDate.format("DD")}日`;
		} else if (view.type === "dayGridDay") {
			data = recordData?.filter(
				(eachRecord) =>
					eachRecord.travel_date === startDate.format("YYYY-MM-DD")
			);
			dayTitle = `${startDate.format("YYYY")}年${startDate.format(
				"MM"
			)}月${startDate.format("DD")}日`;
		} else {
			data = recordData?.filter(
				(eachRecord) =>
					moment(eachRecord.travel_date).format("MM") ===
					middleDate.format("MM")
			);
			dayTitle = `${middleDate.format("YYYY")}年${middleDate.format(
				"MM"
			)}月`;
		}

		const sum_people = data?.reduce(
			(acc, curr) => acc + (curr.total_people_no || 0),
			0
		);

		const newTitle = `${dayTitle} (总人数: ${sum_people ?? 0})`;
		setTitle(newTitle);
	};

	const dayCellContent = (arg) => {
		if (!recordData) {
			return null;
		}

		const dateString = moment(arg.date).format("YYYY-MM-DD");
		const listData = recordData
			.filter((item) => item.travel_date === dateString)
			.sort((a, b) => a.product_subtitle.localeCompare(b.product_subtitle));;
		const total_people = listData.reduce(
			(accumulator, currentItem) =>
				accumulator + currentItem.total_people_no,
			0
		);

		return (
			<div className="custom-day-cell">
				<div style={{ textAlign: "right" }}>{arg.dayNumberText}</div>
				<Card
					onClick={() => showModal(dateString)}
					className="custom-card"
				>
					<div style={{ textAlign: "center" }}>
						<h4>全部人数:{total_people}</h4>
					</div>
					{listData.map((item, index) => (
						// <Tooltip
						// 	key={item.product_id + "_" + index}
						// 	overlayClassName="custom-tooltip"
						// 	color={item.product_color}
						// 	placement="bottom"
						// 	title={
						// 		<ToolTipForm date={dateString} productId={item.product_id} />
						// 	}
						// >
							<Card
								style={{
									marginBottom: 10,
									borderBottom: `1px solid ${item.product_color ?? "#000000"}`,
									borderLeft: `6px solid ${item.product_color ?? "#000000"}`,
									boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
								}}
								key={item.product_subtitle + "_" + index}
							>
								<Badge
									status={
										item.is_allocated === "unallocated"
											? "error"
											: item.is_allocated ===
												"full_allocated"
												? "success"
												: "warning"
									}
									text={
										item.product_subtitle +
										" (" +
										item.total_people_no +
										")"
									}
								/>
							</Card>
						// </Tooltip>
					))}
				</Card>
			</div>
		);
	};

	const renderSumPeopleNo = (dataList) => {
		return dataList.reduce((total, data) => {
			return (
				total +
				data.order_list.reduce((subTotal, item) => {
					return subTotal + item.people_no;
				}, 0)
			);
		}, 0);
	};

	const columns = () => {
		return [
			{
				title: "Order ID",
				dataIndex: "order_id",
				width: "10%",
				key: "order_id",
			},
			{
				title: "分销商",
				dataIndex: "user_name",
				width: "10%",
			},
			{
				title: "上车地点",
				dataIndex: "order_list",
				width: "10%",
				render: (_) => {
					return _[0].pickup_location;
				},
			},
			{
				title: "预约联系人",
				dataIndex: "order_list",
				width: "10%",
				render: (_) => {
					return _[0].client_name;
				},
			},
			{
				title: "原有人数",
				dataIndex: "raw_people_no",
				width: "10%",
			},
			{
				title: "现有人数",
				dataIndex: "order_list",
				width: "10%",
				render: (_) => {
					return _.reduce(
						(accumulator, currentItem) =>
							accumulator + currentItem.people_no,
						0
					);
				},
			},
			{
				title: "备注",
				dataIndex: "comment",
				width: "30%",
				editable: true,
			},
			{
				title: "操作",
				width: "10%",
				render: (record) => {
					return (
						<span>
							<Button
								disabled={record.is_allocated}
								onClick={() => showMoveModal(record)}
								style={{ width: "100%" }}
							>
								{" "}
								移动{" "}
							</Button>
							{record.is_from_web ?
								<Popconfirm
									title="删除订单"
									description="是否要删除这个订单?"
									onConfirm={() => deleteThisRecord(record)}
									icon={
										<QuestionCircleOutlined
											style={{
												color: 'red',
											}}
										/>
									}
								>
									<Button disabled={record.is_allocated}
										style={{ width: "100%" }}>
										{" "}
										删除{" "}
									</Button>
								</Popconfirm>
								: <></>
							}
						</span>
					);
				},
			},
		];
	};

	const mergedColumns = (product_id) => {
		return columns(product_id).map((col) => {
			if (!col.editable) {
				return col;
			}
			return {
				...col,
				onCell: (record) => ({
					record,
					inputType: col.dataIndex === "status" ? "select2" : "text",
					dataIndex: col.dataIndex,
					title: col.title,
					editing:
						typeof col.editable === "function"
							? col.editable(record)
							: col.editable,
					form,
					onDataChange: handleInputChange,
					onSelectChange2: handleSelectChange2,
				}),
			};
		});
	};

	const handleInputChange = (order_id, dataIndex, value) => {
		const newData = JSON.parse(JSON.stringify(allocationData));

		Object.keys(newData).forEach((productId) => {
			newData[productId].forEach((eachOrder) => {
				if (eachOrder.order_id === order_id) {
					eachOrder[dataIndex] = value;
				}
			});
		});

		setAllocationData(newData);
	};

	const handleSelectChange2 = (order_id, selectedStaus) => {
		const newData = JSON.parse(JSON.stringify(allocationData));

		Object.keys(newData).forEach((productId) => {
			newData[productId].forEach((eachOrder) => {
				if (eachOrder.order_id === order_id) {
					eachOrder.status = selectedStaus === "确认";
				}
			});
		});

		setAllocationData(newData);
	};

	const updateFormData = (data) => {
		data.forEach((item) => {
			form.setFieldsValue({
				[`client_name_${item.order_id}`]: item.client_name ?? "",
			});
			form.setFieldsValue({
				[`client_phone_${item.order_id}`]: item.client_phone ?? "",
			});
			form.setFieldsValue({
				[`comment_${item.order_id}`]: item.comment ?? "",
			});
		});
	};

	function onSaveValidate(product_id) {
		let isValid = true;
		let reason = "";

		allocationData[product_id].forEach((item) => {
			item["order_list"].forEach((eachLocation) => {
				if (eachLocation.client_name === "") {
					isValid = false;
					reason = item.order_id + " 请检查姓名";
					return { isValid, reason };
				}
				if (eachLocation.pickup_location === "") {
					isValid = false;
					reason = item.order_id + " 请检查上车地点";
					return { isValid, reason };
				}

				if (
					typeof eachLocation.people_no !== "number" ||
					isNaN(eachLocation.people_no) ||
					eachLocation.people_no % 1 !== 0 ||
					eachLocation.people_no <= 0
				) {
					isValid = false;
					reason = item.order_id + " 请检查人数";
					return { isValid, reason };
				}
			});
		});

		return { isValid, reason };
	}

	async function onSaveandAllocateClick(product_id) {
		if (
			recordData.find(
				(eachRecord) =>
					eachRecord.travel_date === selectedItem &&
					eachRecord.product_id === product_id
			)?.is_allocated === "full_allocated" ??
			false
		) {
			window.location.href = `/allocationDetail?product_id=${product_id}&date=${selectedItem}`;
			return;
		}

		const { isValid, reason } = onSaveValidate(product_id);
		if (isValid) {
			try {
				const response = await updateBatchRecord(
					allocationData[product_id]
				);
				if (response.data.code === "200") {
					message.success("Update successful");
					setTimeout(() => {
						window.location.href = `/allocationDetail?product_id=${product_id}&date=${selectedItem}`;
					}, 1000);
				} else {
					message.error("Something went wrong...");
				}
			} catch (error) {
				message.error("Something went wrong...");
			}
		} else {
			messageApi.open({
				type: "error",
				content: reason,
			});
		}
	}

	async function onSaveClick(product_id) {
		const { isValid, reason } = onSaveValidate(product_id);
		if (isValid) {
			try {
				const response = await updateBatchRecord(
					allocationData[product_id]
				);
				if (response.data.code === "200") {
					message.success("Update successful");
				} else {
					message.error("Something went wrong...");
				}
			} catch (error) {
				message.error("Something went wrong...");
			}
		} else {
			messageApi.open({
				type: "error",
				content: reason,
			});
		}
	}

	const onTempLocationNameChange = (event) => {
		setTempLocationName(event.target.value);
	};

	const addTempLocation = (e) => {
		e.preventDefault();
		if (!LocationList.includes(tempLocationName)) {
			setLocationList([...LocationList, tempLocationName]);
		}

		setTempLocationName("");
		setTimeout(() => {
			inputRef.current?.focus();
		}, 0);
	};

	return (
		<div className="ivt-layout">
			<Layout>
				{contextHolder}
				<Content style={{ margin: "10px" }}>
					<div className="customer-container">
						<FullCalendar
							plugins={[dayGridPlugin, interactionPlugin]}
							locale="zh-cn"
							initialView="dayGridMonth"
							height="auto"
							expandRows={false}
							headerToolbar={{
								left: "prev,next,today",
								center: "title",
								right: "dayGridMonth,dayGridWeek,dayGridDay",
							}}
							buttonText={{
								today: "今天",
								month: "月",
								week: "周",
								day: "日",
							}}
							firstDay={1}
							dayCellContent={dayCellContent}
							datesSet={handleDatesSet}
							titleFormat={() => title}
						/>
					</div>
				</Content>

				<Modal
					title="请检查上车地点以及联系方式"
					open={modalVisible}
					onCancel={handleCancel}
					maskClosable={false}
					width={1500}
					centered
					footer={[
						<Button
							key="add"
							type="primary"
							onClick={showAddModal}
							style={{
								display: "inline-block",
								width: "calc(33.33% - 8px)",
							}}
							size="large"
						>
							新增
						</Button>,
						<Button
							key="cancel"
							onClick={handleCancel}
							style={{
								display: "inline-block",
								width: "calc(33.33% - 8px)",
							}}
							size="large"
						>
							取消
						</Button>,
					]}
				>
					{Object.entries(allocationData).map(
						([product_id, data]) => {
							return (
								<Card
									style={{
										marginBottom: 20,
										boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
									}}
									styles={{
										header: {
											borderLeft: `6px solid ${productList.find((eachProduct) => eachProduct.product_id === product_id)?.product_color ?? "#000000"}`
										},
										body: {
											width: "100%",
											borderLeft: `6px solid ${productList.find((eachProduct) => eachProduct.product_id === product_id)?.product_color ?? "#000000"}`,
											borderBottom: `1px solid ${productList.find((eachProduct) => eachProduct.product_id === product_id)?.product_color ?? "#000000"}`
										}
									}}
									title={
										<Row
											align="middle"
										>
											<Col span={12}>
												{"日期: " +
													selectedItem +
													" 项目: " +
													(productList.find(
														(eachProduct) =>
															eachProduct.product_id ===
															product_id
													)?.product_subtitle ?? "") +
													" 人数: " +
													renderSumPeopleNo(data)}
											</Col>
											{recordData.find(
												(eachRecord) =>
													eachRecord.travel_date ===
													selectedItem &&
													eachRecord.product_id ===
													product_id
											)?.is_allocated ===
												"full_allocated" ?? false ? (
												<Col
													span={12}
													style={{
														display: "flex",
														justifyContent:
															"flex-end",
													}}
												>
													<Button
														key="save"
														type="primary"
														style={{
															display:
																"inline-block",
															width: "calc(33.33% - 8px)",
															margin: "0 8px",
														}}
														size="large"
														onClick={() =>
															onSaveClick(
																product_id
															)
														}
													>
														保存修改
													</Button>
													<Button
														key="assign"
														type="primary"
														style={{
															display:
																"inline-block",
															width: "calc(33.33% - 8px)",
														}}
														size="large"
														onClick={() =>
															onSaveandAllocateClick(
																product_id
															)
														}
													>
														查看分车
													</Button>
												</Col>
											) : (
												<Col
													span={12}
													style={{
														display: "flex",
														justifyContent:
															"flex-end",
													}}
												>
													<Button
														key="save"
														type="primary"
														style={{
															display:
																"inline-block",
															width: "calc(33.33% - 8px)",
															margin: "0 8px",
														}}
														size="large"
														onClick={() =>
															onSaveClick(
																product_id
															)
														}
													>
														保存
													</Button>
													<Button
														key="assign"
														type="primary"
														style={{
															display:
																"inline-block",
															width: "calc(33.33% - 8px)",
														}}
														size="large"
														onClick={() =>
															onSaveandAllocateClick(
																product_id
															)
														}
													>
														保存并分车
													</Button>
												</Col>
											)}
										</Row>
									}
								>
									<Form
										form={form}
										component={false}
										loading={loading}
										key={product_id}
									>
										<Table
											components={{
												body: {
													cell: EditableCell,
												},
											}}
											rowKey={"order_id"}
											bordered
											dataSource={data}
											columns={mergedColumns(product_id)}
											expandable={{
												expandedRowRender: (record) => (
													<List
														itemLayout="vertical"
														size="large"
														dataSource={
															record.order_list
														}
														header={
															<Row
																gutter={[
																	16, 24,
																]}
															>
																<Col
																	span={4}
																	offset={2}
																	style={{
																		textAlign:
																			"center",
																	}}
																>
																	姓名
																</Col>
																<Col
																	span={4}
																	style={{
																		textAlign:
																			"center",
																	}}
																>
																	电话
																</Col>
																<Col
																	span={6}
																	style={{
																		textAlign:
																			"center",
																	}}
																>
																	上车地点
																</Col>
																<Col
																	span={4}
																	style={{
																		textAlign:
																			"center",
																	}}
																>
																	人数
																</Col>
																<Col
																	span={4}
																	style={{
																		textAlign:
																			"center",
																	}}
																>
																	操作
																</Col>
															</Row>
														}
														renderItem={(
															item,
															index
														) => (
															<List.Item
																key={index}
															>
																<Row
																	gutter={[
																		16, 24,
																	]}
																>
																	<Col
																		span={4}
																		offset={
																			2
																		}
																		style={{
																			textAlign:
																				"center",
																		}}
																	>
																		<Input
																			value={
																				item.client_name
																			}
																			style={{
																				width: "100%",
																			}}
																			onChange={(
																				e
																			) => {
																				const newData =
																				{
																					...allocationData,
																				};
																				const indexToUpdate =
																					newData[
																						product_id
																					].findIndex(
																						(
																							dataItem
																						) =>
																							dataItem.order_id ===
																							record.order_id
																					);
																				newData[
																					product_id
																				][
																					indexToUpdate
																				].order_list[
																					index
																				].client_name =
																					e.target.value;
																				setAllocationData(
																					newData
																				);
																			}}
																		/>
																	</Col>
																	<Col
																		span={4}
																		style={{
																			textAlign:
																				"center",
																		}}
																	>
																		<Input
																			value={
																				item.client_phone
																			}
																			style={{
																				width: "100%",
																			}}
																			onChange={(
																				e
																			) => {
																				const newData =
																				{
																					...allocationData,
																				};
																				const indexToUpdate =
																					newData[
																						product_id
																					].findIndex(
																						(
																							dataItem
																						) =>
																							dataItem.order_id ===
																							record.order_id
																					);
																				newData[
																					product_id
																				][
																					indexToUpdate
																				].order_list[
																					index
																				].client_phone =
																					e.target.value;
																				setAllocationData(
																					newData
																				);
																			}}
																		/>
																	</Col>
																	<Col
																		span={6}
																		style={{
																			textAlign:
																				"center",
																		}}
																	>
																		<Select
																			onChange={(
																				value
																			) => {
																				const newData =
																				{
																					...allocationData,
																				};
																				const indexToUpdate =
																					newData[
																						product_id
																					].findIndex(
																						(
																							dataItem
																						) =>
																							dataItem.order_id ===
																							record.order_id
																					);
																				newData[
																					product_id
																				][
																					indexToUpdate
																				].order_list[
																					index
																				].pickup_location =
																					value;
																				setAllocationData(
																					newData
																				);
																			}}
																			placeholder="上车地点"
																			optionLabelProp="label"
																			value={
																				item.pickup_location
																			}
																			defaultActiveFirstOption={
																				false
																			}
																			filterOption={
																				false
																			}
																			style={{
																				width: "100%",
																			}}
																			dropdownRender={(
																				menu
																			) => (
																				<>
																					{
																						menu
																					}
																					<Divider
																						style={{
																							margin: "8px 0",
																						}}
																					/>
																					<Space
																						style={{
																							padding:
																								"0 8px 4px",
																						}}
																					>
																						<Input
																							placeholder="新增临时地点"
																							ref={
																								inputRef
																							}
																							value={
																								tempLocationName
																							}
																							onChange={
																								onTempLocationNameChange
																							}
																							onKeyDown={(
																								e
																							) =>
																								e.stopPropagation()
																							}
																						/>
																						<Button
																							type="text"
																							icon={
																								<PlusOutlined />
																							}
																							onClick={
																								addTempLocation
																							}
																						>
																							增加临时地点
																						</Button>
																					</Space>
																				</>
																			)}
																		>
																			{LocationList.map(
																				(
																					location
																				) => (
																					<Option
																						key={
																							location
																						}
																						value={
																							location
																						}
																						label={
																							location
																						}
																					></Option>
																				)
																			)}
																		</Select>
																	</Col>
																	<Col
																		span={4}
																		style={{
																			textAlign:
																				"center",
																		}}
																	>
																		<InputNumber
																			value={
																				item.people_no
																			}
																			min={
																				0
																			}
																			placeholder="0"
																			style={{
																				width: "100%",
																			}}
																			onChange={(
																				value
																			) => {
																				const newData =
																				{
																					...allocationData,
																				};
																				const indexToUpdate =
																					newData[
																						product_id
																					].findIndex(
																						(
																							dataItem
																						) =>
																							dataItem.order_id ===
																							record.order_id
																					);
																				newData[
																					product_id
																				][
																					indexToUpdate
																				].order_list[
																					index
																				].people_no =
																					value;
																				setAllocationData(
																					newData
																				);
																			}}
																		/>
																	</Col>
																	<Col
																		span={4}
																		style={{
																			textAlign:
																				"center",
																		}}
																	>
																		{index ===
																			0 ? (
																			<Button
																				style={{
																					width: "100%",
																				}}
																				disabled={
																					record.is_allocated ??
																					false
																				}
																				icon={
																					<PlusOutlined />
																				}
																				onClick={() => {
																					const newData =
																					{
																						...allocationData,
																					};
																					const indexToUpdate =
																						newData[
																							product_id
																						].findIndex(
																							(
																								dataItem
																							) =>
																								dataItem.order_id ===
																								record.order_id
																						);
																					const newItem =
																					{
																						order_sub_id:
																							record.order_id +
																							"_" +
																							new Date().getTime(),
																						client_name:
																							"",
																						client_phone:
																							"",
																						pickup_location:
																							"",
																						people_no: 0,
																					};
																					newData[
																						product_id
																					][
																						indexToUpdate
																					].order_list.push(
																						newItem
																					);
																					setAllocationData(
																						newData
																					);
																				}}
																			>
																				新增
																			</Button>
																		) : (
																			<Button
																				style={{
																					width: "100%",
																				}}
																				disabled={
																					record.is_allocated ??
																					false
																				}
																				icon={
																					<CloseOutlined />
																				}
																				onClick={() => {
																					const newData =
																					{
																						...allocationData,
																					};
																					const indexToUpdate =
																						newData[
																							product_id
																						].findIndex(
																							(
																								dataItem
																							) =>
																								dataItem.order_id ===
																								record.order_id
																						);
																					newData[
																						product_id
																					][
																						indexToUpdate
																					].order_list.splice(
																						index,
																						1
																					);
																					setAllocationData(
																						newData
																					);
																				}}
																			>
																				删除
																			</Button>
																		)}
																	</Col>
																</Row>
															</List.Item>
														)}
													/> // 这里可以渲染需要展开的内容
												),
												defaultExpandedRowKeys: ["0"],
											}}
											rowClassName="editable-row"
											pagination={false}
										/>
									</Form>
								</Card>
							);
						}
					)}
				</Modal>

				<Modal
					title="移动订单"
					open={moveModalVisible}
					onCancel={handleMoveCancel}
					maskClosable={false}
					width={800}
					centered
					footer={[
						<Button
							type="primary"
							key="submit"
							onClick={handleMoveSubmit}
							style={{
								display: "inline-block",
								width: "calc(50% - 12px)",
							}}
							size="large"
						>
							保存
						</Button>,
						<Button
							key="back"
							onClick={handleMoveCancel}
							style={{
								display: "inline-block",
								width: "calc(50% - 12px)",
								margin: "0 12px",
							}}
							size="large"
						>
							取消
						</Button>,
					]}
				>
					<Row gutter={[16, 16]}>
						<Col span={12}>
							From:
							<Select
								defaultValue={moveSelectedItem?.product_id}
								disabled
								style={{
									width: "100%",
								}}
							>
								{productList !== undefined ? (
									productList.map((product) => (
										<Option
											key={product.product_id}
											value={product.product_id}
											label={product.product_subtitle}
										>
											<div>{`${product.product_subtitle}`}</div>
										</Option>
									))
								) : (
									<Option></Option>
								)}
							</Select>
						</Col>
						<Col span={12}>
							To:
							<Select
								value={newProductId}
								style={{
									width: "100%",
								}}
								onChange={(value) => setNewProductId(value)}
							>
								{productList !== undefined ? (
									productList.map((product) => (
										<Option
											key={product.product_id}
											value={product.product_id}
											label={product.product_subtitle}
										>
											<div>{`${product.product_subtitle}`}</div>
										</Option>
									))
								) : (
									<Option></Option>
								)}
							</Select>
						</Col>
					</Row>
				</Modal>

				<Modal
					title="新增订单"
					open={addModalVisible}
					onCancel={handleAddCancel}
					maskClosable={false}
					width={800}
					centered
					footer={[
						<Button
							type="primary"
							key="submit"
							onClick={handleAddSubmit}
							style={{
								display: "inline-block",
								width: "calc(50% - 12px)",
							}}
							size="large"
						>
							保存
						</Button>,
						<Button
							key="back"
							onClick={handleAddCancel}
							style={{
								display: "inline-block",
								width: "calc(50% - 12px)",
								margin: "0 12px",
							}}
							size="large"
						>
							取消
						</Button>,
					]}
				>
					<Form
						form={addForm}
						onFinish={handleAddSubmit}
						labelCol={{ span: 8 }}
						wrapperCol={{ span: 16 }}
						style={{ maxWidth: 600, marginTop: "30px" }}
					>
						<Form.Item
							name="order_id"
							label="Order Id"
							rules={[
								{ required: true, message: "请输入订单ID" },
							]}
						>
							<Input />
						</Form.Item>

						<Form.Item
							name="product_id"
							label="项目"
							rules={[{ required: true, message: "请选择项目" }]}
						>
							<Select style={{ width: "100%" }}>
								{productList !== undefined ? (
									productList.map((product) => (
										<Option
											key={product.product_id}
											value={product.product_id}
											label={product.product_subtitle}
										>
											<div>{`${product.product_subtitle}`}</div>
										</Option>
									))
								) : (
									<Option></Option>
								)}
							</Select>
						</Form.Item>

						<Form.Item
							name="user_id"
							label="供应商"
							rules={[{ required: true, message: "供应商" }]}
						>
							<Select style={{ width: "100%" }}>
								{userList !== undefined ? (
									userList?.map((user) => (
										<Option
											key={user.user_detail_id}
											value={user.user_detail_id}
											label={user.user_name}
										>
											<div>{`${user.user_name}`}</div>
										</Option>
									))
								) : (
									<Option></Option>
								)}
							</Select>
						</Form.Item>

						<Form.Item
							name="client_name"
							label="客户姓名"
							rules={[
								{ required: true, message: "请输入客户姓名" },
							]}
						>
							<Input />
						</Form.Item>

						<Form.Item
							name="client_phone"
							label="客户电话"
							rules={[
								{ required: true, message: "请输入客户电话" },
							]}
						>
							<Input />
						</Form.Item>

						<Form.Item name="client_email" label="客户邮箱">
							<Input />
						</Form.Item>

						<Form.Item
							name="price"
							label="价格"
						>
							<InputNumber />
						</Form.Item>

						<Form.Item
							name="pickup_location"
							label="上车地点"
							rules={[
								{ required: true, message: "请选择上车地点" },
							]}
						>
							<Select style={{ width: "100%" }}>
								{LocationList !== undefined ? (
									LocationList.map((location) => (
										<Option
											key={location}
											value={location}
											label={location}
										></Option>
									))
								) : (
									<Option></Option>
								)}
							</Select>
						</Form.Item>

						<Form.Item
							name="child_no"
							label="儿童人数"
							rules={[
								{ required: true, message: "请输入儿童人数" },
							]}
						>
							<InputNumber />
						</Form.Item>

						<Form.Item
							name="adult_no"
							label="成人人数"
							rules={[
								{ required: true, message: "请输入成人人数" },
							]}
						>
							<InputNumber />
						</Form.Item>

						<Form.Item name="comment" label="备注">
							<TextArea />
						</Form.Item>
					</Form>
				</Modal>
			</Layout>
		</div>
	);
};

export default AllocationPage;
